import React, { useContext } from "react";
import ReactPlayer from "react-player";
const HelpVideotab = () => {
  
  return (
    <div>
      <section class="courseschedule1 padding-default bg-color1">
        <div class="row pb-4">
          <div class="col-lg-6 col-sm-6 mb-5 mb-lg-0 hover-style3 text-center text-lg-left">
          <h4 class="mb-3"> How to Access Course Material ?</h4>
              <div  style={{ "height": "320px" , "width":"550px"}}>
              <ReactPlayer
      
                url="https://youtu.be/MbPFbyXMAa4"
                width='100%'
        height='100%'
              />
              </div>
            
           
          </div>
          <div class="col-lg-6 col-sm-6 mb-5 mb-lg-0 hover-style3 text-center text-lg-left">
          <h4 class="mb-3">How to Enroll the edu plus now Courses ? </h4>
          <div  style={{ "height": "320px" , "width":"550px"}}>
              <ReactPlayer
               
                url="https://www.youtube.com/watch?v=mRd4m-Ibh3Y"
                width='100%'
                height='100%'
              />
             </div>
          </div>
        </div>
        <div class="row pb-4">
          
        </div>
      </section>
    </div>
  );
};

export default HelpVideotab;
